@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if ($.row) {
    @let status = $.row.status ?? $.row.guest_pass_status ?? ($.adata?.fetch_key ? $.row[$.adata.fetch_key] : null);
    <div class="flex align-items-center">
      <div
        [ngClass]="getStatusColor(status)"
        class="h-1rem w-1rem border-circle mr-2"
        [attr.data-testid]="'guest-pass-status-dot'"
      ></div>
      <div [attr.data-testid]="'guest-pass-status-label'">
        {{ setGuestPassStatus(status) | titlecase }}
      </div>
    </div>
  }
}
